var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPandoraColorLightPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pandora"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pandora-color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111 24C111 20.1405 114.141 17 118 17C121.859 17 125 20.1027 125 24C125 27.8595 121.859 31 118 31C114.141 31 111 27.8595 111 24ZM122.2 24C122.2 21.6919 120.308 19.8 118 19.8C115.692 19.8 113.8 21.6541 113.8 24C113.8 26.3081 115.692 28.2 118 28.2C120.308 28.2 122.2 26.3081 122.2 24Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.427 18.5892V17.4541H76V30.5459H73.427V29.4108C72.2162 30.3946 70.6649 31 69 31C65.1405 31 62 27.8595 62 24C62 20.1405 65.1405 17 69 17C70.6649 17 72.2162 17.6054 73.427 18.5892ZM64.8 24.0378C64.8 26.4216 66.7297 28.3892 69.1514 28.3892C71.5351 28.3892 73.5027 26.4216 73.5027 24.0378C73.5027 21.6541 71.573 19.6865 69.1514 19.6865C66.7676 19.6865 64.8 21.6162 64.8 24.0378Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.427 18.5892V17.4541H149V30.5459H146.427V29.4108C145.216 30.3946 143.665 31 142 31C138.141 31 135 27.8595 135 24C135 20.1405 138.141 17 142 17C143.665 17 145.216 17.6054 146.427 18.5892ZM137.838 24.0378C137.838 26.4216 139.768 28.3892 142.189 28.3892C144.573 28.3892 146.541 26.4216 146.541 24.0378C146.541 21.6541 144.611 19.6865 142.189 19.6865C139.805 19.6865 137.838 21.6162 137.838 24.0378Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M129.684 18.2912C128.233 19.2688 127 21.0285 127 24.1568V31H129.684V24.1568C129.684 19.6599 134 19.8945 134 19.8945V17.0008C133.964 17.0008 131.642 16.9226 129.684 18.2912Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M89.2 18.4429C88.027 17.546 86.5892 17 85 17C83.4108 17 81.973 17.546 80.8 18.4429C79.0973 19.7688 78 21.8747 78 24.2145V31H80.8V29.9861V24.2145C80.8 21.8357 82.6919 19.8858 85 19.8858C87.3081 19.8858 89.2 21.8357 89.2 24.2145V29.9861V31H92V24.2145C92 21.8357 90.9027 19.7298 89.2 18.4429Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.427 15.3049C105.427 14.5757 105.995 14 106.714 14H108V15.3049V31.5394H105.427V30.3881C104.216 31.3859 102.665 32 101 32C97.1405 32 94 28.8145 94 24.8998C94 20.9851 97.1405 17.7996 101 17.7996C102.665 17.7996 104.216 18.4136 105.427 19.4115V15.3049ZM96.8 24.9382C96.8 27.3561 98.7297 29.3518 101.151 29.3518C103.573 29.3518 105.541 27.3561 105.503 24.9382C105.503 22.5203 103.573 20.5245 101.151 20.5245C98.7676 20.5245 96.8 22.4819 96.8 24.9382Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.573 18.6085C49.7838 17.6128 51.3351 17 53 17C56.8973 17 60 20.1404 60 24.0851C60 27.9915 56.8973 31.1702 53 31.1702C51.3351 31.1702 49.7838 30.5574 48.573 29.5617V33.6979C48.573 34.4255 48.0054 35 47.2865 35H46V33.6979V17.4596H48.573V18.6085ZM48.4973 24.0851C48.4973 26.4979 50.427 28.4894 52.8486 28.4894C55.2703 28.4894 57.2 26.4979 57.2 24.0851C57.2 21.6723 55.2324 19.6809 52.8486 19.6809C50.4649 19.6809 48.4973 21.634 48.4973 24.0851Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 16.5C150 17.3382 150.662 18 151.5 18C152.338 18 153 17.3382 153 16.5C153 15.6618 152.338 15 151.5 15C150.662 15 150 15.6618 150 16.5ZM150.176 16.5C150.176 15.75 150.75 15.1765 151.5 15.1765C152.206 15.1765 152.824 15.75 152.824 16.5C152.824 17.2059 152.25 17.8235 151.5 17.8235C150.75 17.8235 150.176 17.2059 150.176 16.5ZM151.897 17.3824L151.456 16.7206H151.147V17.3824H150.926V15.6618H151.632C151.941 15.6618 152.162 15.8824 152.162 16.1912C152.162 16.5882 151.809 16.7206 151.721 16.7206L152.162 17.4265H151.897V17.3824ZM151.147 15.8382H151.632C151.765 15.8382 151.941 15.9706 151.941 16.1912C151.941 16.3676 151.765 16.5 151.632 16.5H151.147V15.8382Z",
    fill: "#00A0EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandoraColorLightPadding);
export default __webpack_public_path__ + "static/media/pandora-color-light-padding.9a64b793213034ef4be8c8681a51ab17.svg";
export { ForwardRef as ReactComponent };